// extracted by mini-css-extract-plugin
export default {"header":"pageHeader_header__3LkMO","title":"pageHeader_title__UCU16","backBtn":"pageHeader_backBtn__vmDpJ","children":"pageHeader_children__Lzr-E"};